export default "__VITE_ASSET__BwrggwQv__"